<template>
  <div class="container">
      <div class="title0">
        <!-- 标题文字 -->
        <img :src="url+'/img/xaiofei/data1/bt.png'" class="titTxt" />
        <router-link :to="{path:'/'}"><img :src="url+'/img/xaiofei/sy.png'" class="return return1" /></router-link>
        <img :src="url+'/img/xaiofei/fh.png'" class="return return2" @click="clickReturn" />
        <img :src="url+'/img/zhibo/gx.png'" class="guang1" />
        <img :src="url+'/img/zhibo/gx.png'" class="guang2" />
      </div>
      <div class="content">
        <!-- 左侧 -->
        <div class="leftNavbox">
          <!-- 左侧-左侧 -->
          <div class="navItem" :class="{navItemCur:leftNavCur==index}" v-for="(item,index) in leftNav" :key="index">
            <div class="left_mgBox"><img :src="item.icon" /></div>
            <div class="right_font"><span>{{item.tit}}</span><span>{{item.subTit}}</span></div>
          </div>
        </div> 
         <!--中间地图  -->
        <div class="center">
           <!-- 中心物体 -->
          <!-- <div class="mapIcon1">
            <img :src="url+'/img/jiagong/mapIcon3.gif'" class="animate__animated animate__bounce"  />
           <span class="span">车间详情</span>
            <div class="centerInfo animate__animated " :class="showDiv?'animate__bounceIn' :'animate__bounceOut'"  v-if="showDiv">
              <h3>车间详情</h3>
              <div class="jkXq">
                <div class="jkItemA" v-for="(item,index) in jiankongList" :key="index">
                  <div class="jkItemB" v-for="(item0,index0) in item" :key="index0">
                    <span>{{item0.name}}：</span><span>{{item0.value}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mapIcon2">
            <img :src="url+'/img/jiagong/mapIcon3.gif'" class="animate__animated animate__bounce"  />
            <span class="span">监控详情</span>
            <div class="centerInfo animate__animated" :class="!showDiv?'animate__bounceIn' :'animate__bounceOut'" v-if="!showDiv">
              <h3>监控详情</h3>
              <div class="jkXq">
                <div class="jkItemA" v-for="(item,index) in jiankongList" :key="index">
                  <div class="jkItemB" v-for="(item0,index0) in item" :key="index0">
                    <span>{{item0.name}}：</span><span>{{item0.value}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <!-- 右侧 -->
        <div class="rightBox">
          <!-- 右一左 -->
          <div class="right_left">
            <div class="right_tab">
              <div class="right_tab_tit">
                <span>蔡州农芯谷</span>
                <span>{{right_tabList[right_tab_cur].name}}</span>
              </div>
              <div class="right_tab_list">
                <div class="right_tab_list_item" v-for="(item,index) in right_tabList" :key="index" @click="tabClick(index)">
                  <div class="imgIcon" :class="{imgIcon2:right_tab_cur==index}"></div>
                  <span class="fang" :class="{fang1:right_tab_cur==index}">{{item.tit}}</span>
                  <div class="imgIcon imgIcon1" :class="{imgIcon2:right_tab_cur==index}"></div>
                </div>
              </div>
            </div>
            <div class="right_left_con">
              <!-- 园区简介 -->
              <div class="right_left_conA">
                <div class="title">{{right_tabList[right_tab_cur].name}}</div>
                <div class="right_left_conA_a">
                  <div class="txt animate__animated animate__fadeInUp" v-if="right_l_isShow">{{right_tabList[right_tab_cur].intro}}</div>  
                </div>
                <div class="right_left_conA_b">
                  <div class="right_left_conA_item" v-for="(item,index) in right_tab_tit" :key="index">
                    <div class="right_left_conA_item_num">{{item.tit}}</div>
                    <div class="right_left_conA_item_name">{{item.name}}</div>
                  </div>
                </div>
              </div>
              <!-- 园区平面图 -->
              <div class="right_left_conB">
                <div class="title">园区平面图</div>
                <div class="right_left_conB_box">
                  <img src="../assets/img/yuanqu/pmt.jpg" />
                </div>
              </div>
            </div>
          </div>
          <div class="right_right">
            <!-- 园区培训 -->
            <div class="right_right_A">
              <div class="title">园区培训</div>
              <div class="right_right_A_a">
                <div>主播总人数<span>284</span>人</div>
                <div class="right_right_A_a_right">
                  <div class="yuan"></div>
                  <img src="../assets/img/yuanqu/rs.png" />
                </div>
              </div>
              <div class="right_right_A_b">
                <div class="right_right_A_b_item" v-for="(item,index) in right_r_data1" :key="index">
                  <div class="right_right_A_b_item_top"><img :src="item.icon" /><span>{{item.value}}</span></div>
                  <div class="right_right_A_b_item_center"><span class="line"></span><div class="circle"></div></div>
                  <div class="right_right_A_b_item_bottom">{{item.name}}</div>
                </div>
              </div>
            </div>
            <!-- 园区监控 -->
            <div class="right_right_B">
              <div class="title">园区监控</div>
              <div class="right_right_B_video">
                <div class="right_right_B_video_item" v-for="(item,index) in right_r_data2" :key="index" @click="videoClick(index)">
                  <img :src="item.img" class="fm" />
                  <div class="video_tit">
                    <span>{{item.name}}</span>
                    <img src="../assets/img/yuanqu/dw.png" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
   <footer1 />
   <!-- 弹出视频 -->
   <popBg :title="right_r_data2[curVideoIndex].name" :popShow="popShow" @hiddlen="popHiddlen">
    <vue3VideoPlay id="video"  width="100%"  height="100%"  title="冰河世纪"  :src="right_r_data2[curVideoIndex].options.src"  :type="right_r_data2[curVideoIndex].options.type"  :autoPlay="true"/>
  </popBg>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import * as THREE from 'three';
import { useRouter } from 'vue-router'
import countTo from"@/components/vue-count-to/src/vue-countTo.vue"
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
// 


import popBg from "../components/popBg.vue"
import footer1 from "../components/footer.vue";


export default {
  name: "Home",
  setup() {
    const { appContext  } = getCurrentInstance();
    const timer = ref(null);
    const router = useRouter();
    const state = reactive({
      url:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      leftNav:[
        {tit:"园区总览",subTit:"YUANQUZONGLAN",icon:require("../assets/img/yuanqu/leftnav/zl_hover.png")},
        {tit:"培训基地",subTit:"PEIXUNJIDI",icon:require("../assets/img/yuanqu/leftnav/px_hover.png")},
        {tit:"加工基地",subTit:"JIAGONGJIDI",icon:require("../assets/img/yuanqu/leftnav/jg_hover.png")},
        {tit:"质检基地",subTit:"ZHIJIANJIDI",icon:require("../assets/img/yuanqu/leftnav/zj_hover.png")},
        {tit:"种植大棚",subTit:"ZHONGZHIDAPENG",icon:require("../assets/img/yuanqu/leftnav/zz_hover.png")},
      ],
      leftNavCur:0,
      right_tabList:[
        {tit:"A0",name:"园区简介",intro:"上蔡县国家农村产业融合发展示范园（中国蔡州农芯谷）位于上蔡县城西部，毗邻G345西上公路。园区2019年经国家发改委批准立项，规划面积2745亩，总投资5.5亿元。2020年9月被国家发改委等七部委批准为国家级农村产业融合发展示范园。示范园区按照“种、养、加、销、游”全产业链一体化开发的思路，探索创新“农业+”“生态+”“旅游+”等经营模式，推动现代农业和农产品加工业、现代服务业互融共通、耦合发展，最终实现了农业产业链延伸、产业范围扩展，增值收益共享。"},
        {tit:"A1",name:"生态农业",intro:"上蔡县状元红生态农业科技有限公司创建于2017年，获得了多个绿色食品级证书。"},
        {tit:"A2",name:"状元红酒业",intro:"状元红酒酿造距今已有300多年的历史。1970年县副食品加工厂开设了白酒生产线。2013年河南上蔡状元红酒业有限公司投资1.5亿元兴建上蔡县状元红酒文化产业园，2014年投料生。产目前年产原酒1080吨，日生产成品酒6000件，产品销往省内外。驻马店市非物质文化遗产酿造酒技艺(重阳菊花酒酿造技艺)。"},
        {tit:"A3",name:"生态温泉酒店",intro:"状元红生态温泉酒店是一家集餐饮、文化娱乐休闲度假功能于一体的综合性酒店。酒店主营粤菜川菜及地方特色美食。酒店拥有可容纳300人的宴会厅200人的会议室和户外草坪，温泉水汇设有230m标准室内泳池，温泉泡池及室外泡池，并配套儿童乐园。"},
        {tit:"A4",name:"建业大食堂",intro:"河南建业大食堂餐饮文化有限公司是一家专业化、连锁化、平台化运营的餐饮管理企业，公司以弘扬中华传统饮食文化，发掘、保护及传承中原传统名吃为企业使命，致力于打造：中原美食民俗文化体验地、舌尖上的河南、河南人的待客厅。"},
        {tit:"A5",name:"养老中心",intro:"状元红资敬园，是一家致力解决认知综合症的专业养老机构。养老中心项目占地80亩，总建筑面积10000平方米，设有96个房间，120张床位。项目规划建设4500m老年文体中心1座主要包括书歌舞画教室、教室、老年大学等。"},
        {tit:"A6",name:"状元红检测",intro:"河南状元红检测技术有限公司成立于2016年，是通过省级资质认定的食品检测机构。公司拥有各类检测设备133套，精度高性能均达到国内外先进水平。公司立足上蔡，面向驻马店，辐射周边，已成为豫南最大的检测中心。"},
      ],
      right_tab_tit:[
        {tit:"A1",name:"生态农业"},
        {tit:"A2",name:"状元红酒业"},
        {tit:"A3",name:"生态温泉酒店"},
        {tit:"A4",name:"建业大食堂"},
        {tit:"A5",name:"养老中心"},
        {tit:"A6",name:"状元红检测"},
      ],
      right_tab_cur:0,
      right_l_isShow:true,
      right_r_data1:[
        {name:"未孵化",value:869,icon:require("../assets/img/yuanqu/wfh.png")},
        {name:"孵化中",value:36,icon:require("../assets/img/yuanqu/fhz.png")},
        {name:"已孵化",value:82669,icon:require("../assets/img/yuanqu/yfh.png")}
      ],
      right_r_data2:[
        {
          name:"生态农业",img:require("../assets/img/yuanqu/videoimg/img1.png"),
          options:{
            src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/zhibo.mp4", //视频源
            type: 'video/mp4', //视频类型
          },
        },{
          name:"状元红酒业",img:require("../assets/img/yuanqu/videoimg/img2.png"),
          options:{
            src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/zhibo.mp4", //视频源
            type: 'video/mp4', //视频类型
          },
        },{
          name:"状元红检测",img:require("../assets/img/yuanqu/videoimg/img3.png"),
          options:{
            src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/zhibo.mp4", //视频源
            type: 'video/mp4', //视频类型
          },
        },{
          name:"建业大食堂",img:require("../assets/img/yuanqu/videoimg/img4.png"),
          options:{
            src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/zhibo.mp4", //视频源
            type: 'video/mp4', //视频类型
          },
        },
      ],
      curVideoIndex:0,
      popShow:false,
      showDiv:true
    });
     onMounted(() => {
      // setInterval(() => {
      //   state.showDiv = !state.showDiv
      // }, 6000);
    })
    onUnmounted(() => {
      
      
    });
    onBeforeUnmount(() => {
     
    })
     // 返回上一页
    function clickReturn(){
      console.log("kk")
        router.go(-1);
    }
    function close(){
      state.isShow=!state.isShow
    }
    function tabClick(index){
      this.right_l_isShow = false; // 点击后先隐藏div
      state.right_tab_cur = index
        setTimeout(() => {
          this.right_l_isShow = true; // 200ms后再重新显示div（模拟刷新）
        }, 200);
    }
    // 弹出视频
    function videoClick(index1){
      console.log(index1)
      state.popShow = true
      state.curVideoIndex = index1
    }
    // 关闭弹出
    function popHiddlen(){
      state.popShow = false
    }
    return {
      ...toRefs(state),
      close,
      clickReturn,
      tabClick,
      videoClick,
      popHiddlen
    };
  },
  components: {
      popBg,
      footer1,
     
  },
};
</script>
<style lang="less" scoped>
a{color: #fff;display: block;width: 100%;height: 100%;}
body {
  background-size: cover;
  line-height: 1.15;
}
@font-face {
  font-family: electronicFont;
  src: url("../assets/font/DS-DIGIT.TTF");
}

#video .d-player-wrap {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}

// 修改右侧产品带货列表列表样式
::v-deep .dv-scroll-board .rows .row-item,::v-deep .dv-scroll-board .header{
  font-size: 30px;
}
.container{
  width: 100%;
  height: 100vh;
  background: url("../assets/img/yuanqu/bg.jpg") no-repeat top center;
  background-size: 100% 100%!important;
  color: #fff;
  position: relative;
  .title0{
    width: 100%;
    height: 554px;
    background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/btbj.png") no-repeat top center;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    .titTxt{
      width: 2347px;
      height: 93px;
      position: absolute;
      top: 36px;
      left: 50%;
      margin-left: -1173.5px;
    }
    .return{
      width: 81px;
      height: 38px;
      cursor: pointer;
      transform: scale(2);
      position: absolute;
      top: 100px;
    }
    .return1{
      left: 100px;
    }
    .return2{
      right: 100px;
    }
    .guang1{
      position: absolute;
      top: -34px;
      left: 0;
      animation: titleGuang1 2s linear infinite;
      z-index: 0;
    }
    .guang2{
      position: absolute;
      top: -34px;
      right: 0;
      animation: titleGuang2 2s linear infinite;
    }
    @keyframes titleGuang1{
      0%{
        left: 0;
      }
      100%{
        left: 15%;
      }
    }
    @keyframes titleGuang2{
      0%{
        right: 0;
      }
      100%{
        right: 15%;
      }
    }
  }
  .content{
    position: absolute;
    top: 300px;
    left: 0;
    width: 100%;
    height: calc(100% - 300px);
    display: flex;
    position: relative;
    padding: 20px 80px 48px;
    box-sizing: border-box;
    // 左侧导航
    .leftNavbox{
      width: 450px;
      margin-left: 256px;
      .navItem{
        display: flex;
        margin: 40px 0;
        cursor: pointer;
        transition: all 1s ease-out;
        .left_mgBox{
          width: 165px;
          height: 142px;
          background: url("../assets/img/yuanqu/leftnav/wxz.png") no-repeat;
          background-size: 100% 100%!important;
          padding-right:23px ;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: all 1s ease-out;
          img{
            width: 62px;
            height: 62px;
            transition: all 1s ease-out;
          }
        }
        .right_font{
          display: flex;
          flex-direction: column;
          justify-content: center;
          font-size: 48px;
          text-align: left;
          margin-left: 20px;
          transition: all 1s ease-out;
          span:nth-child(2){
            font-size: 24px;
            margin-top: 10px;
            color: #A5D8FC;
          }
        }
      }
      .navItemCur,.navItem:hover{
        transition: all 1s ease-out;
        .left_mgBox{
          background: url("../assets/img/yuanqu/leftnav/xz.png") no-repeat;
          transition: all 1s ease-out;
          img{
            width: 88px;
            height: 88px;
            transition: all 1s ease-out;
          }
        }
        .right_font{
          margin-left: 50px;
          transition: all .5s ease-out;
        }
      }
      .navItemCur{
        .right_font{
          margin-left: 20px;
        }
      }
    }
    .center{
      flex: 1;
      height: 100%;
      .mapIcon1{
        position: absolute;
        top:-2%;
        left: 1%;
        img{
          width: 80px;
        }
        .span{
          text-shadow:2px 2px 10px rgba(0, 0, 0, 1), ;
          position: absolute;
          top: 12px;
          left: 70px;
          width: 180px;
          font-size: 40px;
          text-align: left;
        }
      }
      .mapIcon2{
        position: absolute;
        top:29%;
        left: 50%;
        img{
          width: 80px;
        }
        .span{
          text-shadow:2px 2px 10px rgba(0, 0, 0, 1), ;
          position: absolute;
          top: 16px;
          left: 80px;
          width: 180px;
          font-size: 40px;
          text-align: left;
        }
      }
    }
    // 右側
    .rightBox{
      width: 2528px;
      height: 100%;
      padding: 12px 12px 0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      height: 100%;
      // 右-左
      .right_left{
        height: 100%;
        flex: 1;
        display: flex;
        margin-right: 200px;
        .right_tab{
          width: 237px;
          margin-right: 50px;
          .right_tab_tit{
            width: 100%;
            height: 118px;
            background: url("../assets/img/yuanqu/mc.png") no-repeat;
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: 24px;
            line-height: 40px;
            padding: 24px 26px 0 0;
            text-align: right;
            span:nth-child(2){
              color: #63707F;
            }
          }
          .right_tab_list{
            width: 100%;
            height: 100%;
            background: url("../assets/img/yuanqu/x.png") no-repeat top right;
            margin-top: 20px;
            .right_tab_list_item{
              flex: 1;
              display: flex;
              margin-bottom: 20px;
              cursor: pointer;
              transition: all .5s ease-out;
              .imgIcon{
                width: 27px;
                height: 117px;
                display: flex;
                align-items: center;
                transition: all .5s ease-out;
              }
              .imgIcon1{
                transform: rotate(180deg);
              }
              .imgIcon2{
                  background: url("../assets/img/yuanqu/zjt.png") no-repeat left center;
                }
              .fang{
                width: 117px;
                height: 117px;
                background: url("../assets/img/yuanqu/wxz1.png") no-repeat;
                text-align: center;
                line-height: 117px;
                font-size: 36px;
                margin: 0 27px;
                transition: all .5s ease-out;
              }
              .fang1{
                background: url("../assets/img/yuanqu/xzyq.png") no-repeat;
                transition: all .5s ease-out;
              }
            }
            .right_tab_list_item:hover{
              transition: all .5s ease-out;
              .fang{
                background: url("../assets/img/yuanqu/xzyq.png") no-repeat;
                transition: all .5s ease-out;
              }
              .imgIcon{
                background: url("../assets/img/yuanqu/zjt.png") no-repeat left center;
                transition: all .5s ease-out;
              }
              
            }
          }
        }
        .right_left_con{
          height: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          .right_left_conA{
            width: 100%;
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            .right_left_conA_a{
              width: 100%;
              flex: 1;
              font-size: 30px;
              text-align: left;
              line-height: 50px;
              color: #E4F3FF;
              padding: 0 20px;
              text-indent: 2em;
              box-sizing: border-box;
              overflow: hidden;
              .txt{
                width: 100%;
                height: 100%;
                overflow-y: auto;
                box-sizing: border-box;
              }
            }
            .right_left_conA_b{
              width: 100%;
              height: 318px;
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
              padding: 20px 0;
              box-sizing: border-box;
              .right_left_conA_item{
                // margin: 10px 0;
                .right_left_conA_item_num{
                  line-height: 30px;
                  font-size: 30px;
                  color: #778189;
                }
                .right_left_conA_item_name{
                  width: 324px;
                  height: 109px;
                  background: url("../assets/img/yuanqu/zmj.png") no-repeat;
                  line-height: 109px;
                  font-size: 36px;
                  color: #00F8F4;
                  transform: scale(.9);
                }
              }
            }
          }
          .right_left_conB{
            width: 100%;
            height: 526px;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            .right_left_conB_box{
              width: 954px;
              height:416px ;
              background: url("../assets/img/yuanqu/bk.png") no-repeat;
              padding: 20px;
            }
          }
        }
      }
      .right_right{
        width: 1012px;
        height: 100%;
        // border: 1px solid;
        display: flex;
        flex-direction: column;
        .right_right_A{
          width: 100%;
          height: 604px;
          .right_right_A_a{
            width: 927px;
            height: 220px;
            border: 6px solid rgba(102,228,255,.6);
            border-radius: 46px;
            margin: 0 auto;
            padding: 0 50px 0 90px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 40px;
            span{
              color: #00F8F4;
              font-size: 50px;
              margin: 0 20px 0 100px;
            }
            .right_right_A_a_right{
              width: 157px;
              height: 158px;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
               .yuan{
                position: absolute;
                top: 0;
                left: 0;
                width: 157px;
                height: 158px;
                background: url("../assets/img/yuanqu/yq.png") no-repeat; 
                animation: rightCircle 10s linear infinite;
              }
              img{
                animation: scale1 1s linear infinite;
              }
            }
           
          }
          .right_right_A_b{
            display: flex;
            justify-content: space-between;
            padding: 0 100px;
            margin: 80px 0;
            .right_right_A_b_item{
              width: 200px;
              .right_right_A_b_item_top{
                display: flex;
                padding: 0 20px 10px;
                display: flex;
                align-items: center;
                img{
                  width: 60px;
                  height: 63px;
                  margin-right: 20px;
                }
                span{
                  font-size: 40px;
                  color: #E4F3FF;
                }
              }
              .right_right_A_b_item_center{
                display: flex;
                align-items: center;
                .line{
                  flex: 1;
                  height: 4px;
                  background: #84C3D5;
                }
                .circle{
                  width: 18px;
                  height: 18px;
                  border-radius: 50%;
                  border: 4px solid #84C3D5;;
                }
              }
              .right_right_A_b_item_bottom{
                font-size: 36px;
                padding-top: 10px;
              }
            }
          }
        }
        .right_right_B{
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          .right_right_B_video{
            width: 100%;
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .right_right_B_video_item{
              width: 451px;
              height: 217px;
              position: relative;
              .fm{
                width: 100%;
                height: 100%;
              }
              .video_tit{
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 60px;
                padding: 0 20px;
                box-sizing: border-box;
                background: linear-gradient(to right, rgba(10,189,186,.5) 0,rgba(38,51,67,.8) 50%,rgba(38,51,67,.8) 50%,rgba(38,51,67,.5) 75%, rgba(10,189,186,.5) 100%);
                display: flex;
                justify-content: space-between;
                align-items: center;
                img{
                  width: 36px;
                  height: 43px;
                  transform: scale(.9);
                }
                span{
                  display: block;
                  font-size: 30px;
                  flex: 1;
                  height: 60px;
                  overflow: hidden;
                  text-align: left;
                  line-height: 60px;
                  margin-right: 30px;
                }
              }
            }
          }
        }
      }
    }
 
    
    .center{
      flex: 1;
      height: 100%;
      position: relative;
      margin: 0 30px;
      
    }

    // 标题
    .title{
      width: 1012px;
      height: 74px;
      text-align: left;
      background: url("../assets/img/yuanqu/xbt.png") no-repeat left bottom;
      padding-left: 30px;
      box-sizing: border-box;
      animation: title 3s linear infinite;
      display: flex;
      justify-content: space-between;
      font-size: 48px;
      color: #A5D8FC;
      padding-left: 110px;
      margin-bottom: 30px;
    }

  }
}


// 轨道旋转动画b
@keyframes spin {
  0% {
    transform: scaleY(0.5) rotate(0deg);
  }
  100% {
    transform: scaleY(0.5) rotate(360deg);
  }
}
@keyframes anti-spin {
  0% {
    transform: rotate(0deg) scaleY(2) scale(1);
  }
  100% {
    transform: rotate(-360deg) scaleY(2) scale(1);
  }
}
// 轨道


@keyframes scale1{
    0%{transform:scale(1)}
    50%{transform:scale(1.08);}
    100%{transform:scale(1)}
}
 @keyframes scale{
    0%{transform:scale(1)}
    50%,75%{transform:scale(2)}
    78%,100%{opacity:0}
}
@keyframes title {  
  0%{                     
      background-position: 0 bottom;
  } 
  50%{
    background-position: 10px bottom;
  }
   100%{
    background-position: 0 bottom;
  }
}
@keyframes bianda {  

  0%{                     
      // transform: scale(0.96);
      filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0));
  } 
  50%{
    // transform: scale(1);
    filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.5));
  }
   100%{
    // transform: scale(0.96);
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0));
  }
}
@keyframes jiantou {  

  0%{                     
      right: 90px;
  } 

  50%{
    right: 95px;
  }
   100%{
    right: 90px;
  }
}

@keyframes guangying {  
 0%{                     
      transform: scale(0.96);
      filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
  } 

  50%{
    transform: scale(1);
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));
  }
   100%{
    transform: scale(0.96);
    filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
  }
}


@keyframes rightCircle { 
  0% {
          transform: rotate(0deg);
      }

  100% {
      transform: rotate(360deg);
  }
}

 @keyframes rotate {
    0% {
        transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg);
    }
    100% {
        transform: rotateX(0deg) rotateY(0deg) rotateZ(360deg);
    }
 }

// 左侧矩形
@keyframes leftJx {    /*引用动画名称*/
  0% {
          box-shadow: inset 0 0 5px 2px rgba(55, 199, 219, .5);
      }
  50% {
        box-shadow: inset 0 0 10px 2px rgba(55, 199, 219, .5);
    }

  100% {
      box-shadow: inset 0 0 5px 2px rgba(55, 199, 219, .5);
  }
}
</style>
